import { DbStatusType } from '../types/db-status.type';
import { ObjectStatus } from '../types/misc.type';
import { Analgesia, AnalgesiaClass } from './analgesia.model';
import { DeviceData, DeviceDataClass } from './device-data.model';
import { Owner, OwnerClass } from './documtent-owner.model';
import {
  RecordingTimings,
  RecordingTimingsClass,
} from './recording-timings.model';
import { VideoFiles, VideoFilesClass } from './video-files.model';
import { extractDateTimeStamp } from '../utils/date-timestamp-extraction';
import { JuliaData, ResnetLongeingData } from '../resnet-struct';
import {
  RecordingAnalysis,
  RecordingAnalysisClass,
} from './recording-analysis.model';
import { LinkedRecordings } from './linked-recordings.model';
import { AnalysisType } from '../types';

import { Tag, TagCategory } from '../tags/tag.model';

export { Tag, TagCategory };
export type RecordingTag = Tag;
export type RecordingTags =
  | Partial<Record<TagCategory, Record<string, Tag>>>
  | Tag[]
  | Record<string, Tag>;


/** We are still supporting a mix of recording models this one is the latest, but needs to be updated,
 * We need to add Satisfies as of TypeScript 4.9 but not updated yet.
 */
export interface Recording {
  id?: string;
  recordingId?: string;
  analgesia: Analgesia;
  analysis: RecordingAnalysis;
  analysisType: AnalysisType;
  comments: any;
  creationDate: Date | null;
  deviceData: DeviceData;
  dbStatus: DbStatusType;
  firestoreId?: string;
  horseId: string;
  owner: Owner;
  status: ObjectStatus;
  priority: string;
  uploadType: string;
  uploadedBy: string;
  description?: string; // Moved object from description;
  videofiles?: VideoFiles;
  timings: RecordingTimings;
  mimirCreated: boolean; // variable for testing without trigger backend flow
  mimirAnalysis: boolean; // A way for us to determine if analysis has been generated by mimir or not
  retriggered: boolean;
  iOSfallbackWrite: boolean;
  juliaData: JuliaData | null;
  longeingData: ResnetLongeingData | null;
  horseName?: string;
  useHorseRelativeScaling?: boolean;
  linkedRecordings?: LinkedRecordings;
  tags?: RecordingTags | null;
}

export class RecordingClass implements Recording {
  id?: string | undefined;
  recordingId?: string;
  analgesia: Analgesia;
  analysis: RecordingAnalysis;
  comments: any;
  analysisType: AnalysisType;
  creationDate: Date | null;
  deviceData: DeviceData;
  dbStatus: DbStatusType;
  firestoreId?: string;
  horseId: string;
  owner: Owner;
  status: ObjectStatus;
  priority: string;
  uploadType: string;
  uploadedBy: string;
  description?: string;
  videofiles: VideoFiles;
  timings: RecordingTimings;
  mimirCreated: boolean;
  mimirAnalysis: boolean;
  retriggered: boolean;
  iOSfallbackWrite: boolean;
  juliaData: JuliaData | null;
  longeingData: ResnetLongeingData | null;
  horseName?: string;
  useHorseRelativeScaling?: boolean;
  linkedRecordings?: LinkedRecordings;
  tags?: RecordingTags | null;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.recordingId = o['recordingId'] ?? null;
    this.analgesia = new AnalgesiaClass(o['analgesia'] ?? {});
    this.analysis = new RecordingAnalysisClass(o['analysis'] ?? {}); // complete this
    this.analysisType = o['analysisType'] ?? null;
    this.comments = o['comments'] ?? null;
    this.creationDate = extractDateTimeStamp(o['creationDate']);
    this.deviceData = new DeviceDataClass(o['deviceData'] ?? {});
    this.dbStatus = o['dbStatus'] ?? null;
    this.firestoreId = o['firestoreId'] ?? null;
    this.horseId = o['horseId'] ?? null;
    this.owner = new OwnerClass(o['owner'] ?? {});
    this.status = o['status'] ?? null;
    this.priority = o['priority'] ?? null;
    this.uploadType = o['uploadType'] ?? null;
    this.uploadedBy = o['uploadedBy'] ?? null;
    this.description = o['description'] ?? null;
    this.videofiles = new VideoFilesClass(o['videofiles'] ?? {});
    this.timings = new RecordingTimingsClass(o['timings'] ?? {});
    this.mimirCreated = o['mimirCreated'] ?? null;
    this.mimirAnalysis = o['mimirAnalysis'] ?? null;
    this.retriggered = o['retriggered'] ?? null;
    this.iOSfallbackWrite = o['iOSfallbackWrite'] ?? null;
    this.juliaData = o['juliaData'] ?? null;
    this.longeingData = o['longeingData'] ?? null;
    this.horseName = o['horseName'] ?? null;
    this.useHorseRelativeScaling = o['useHorseRelativeScaling'] ?? null;
    this.linkedRecordings = new LinkedRecordings(o['linkedRecordings'] ?? {});
    this.tags = o['tags'] ?? null;
  }
}
